module.exports = __webpack_public_path__ + "dimer/static/img/11.29264ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/11.jpg
// module id = OJZR
// module chunks = 0